/* ============================================================
   ToTheLove — Avant / Apres (assets/tothelove-before-after.js)
   Custom element <ttl-before-after>.
   Le drag/clavier est entierement gere par l'<input type="range">
   natif (invisible, plein cadre) : le JS ne fait que reporter sa
   valeur dans la variable CSS --ttl-ba-pos.
   Scoping strict [data-ttl-ba-*]. Re-init auto dans le Theme Editor
   (connectedCallback rejoue au re-render de la section).
   ============================================================ */

if (!customElements.get('ttl-before-after')) {
  customElements.define(
    'ttl-before-after',
    class TTLBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-ttl-ba-range]');
        if (!this.range) return;

        this.onInput = () => {
          this.style.setProperty('--ttl-ba-pos', `${this.range.value}%`);
        };

        this.range.addEventListener('input', this.onInput);
        this.onInput();
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.onInput);
      }
    }
  );
}
